import { createEffect, createEvent, createStore, merge } from 'effector';
import { createGate } from 'effector-react';
import { pending } from 'patronum';
import { $timezone } from '@features/common';
import { getCookie } from '@tools/cookie';
import { ChildBase, GeneralJsonTypeBase } from '@unicorn/sdui';
import { sdui } from './api';
import {
  CreateTicketPayload,
  CreateUpdateTicketResponse,
  GetFieldsPayload,
  GetFieldsResponse,
  PreLoadValues,
  TicketData,
  UpdateTicketPayload,
} from './types';

export const baseSduiConfig = {
  log: false,
  apiTimeout: 30000,
  custom: {
    app: 'crm',
    token: getCookie('bms_token'),
    timezone: ($timezone as any).stateRef.current,
  },
};

export const INPUT_SPEC_START = 'input';
export const NEW_OPENED_ID = 'new';

export const CustomFieldsGate = createGate<
  { openedId: string | number | null } & PreLoadValues
>();

export const $customFieldsSduiJson = createStore<GeneralJsonTypeBase | null>(null);
export const $sduiTicketData = createStore<TicketData>({} as TicketData);

export const getCustomFieldsSduiJson = createEvent<
  {
    openedId?: string | number;
  } & PreLoadValues
>();

export const fxGetCustomFieldsSduiJson = createEffect<
  GetFieldsPayload,
  GetFieldsResponse,
  Error
>().use(sdui.getCustomFields);

export const createSduiTicket = createEvent<ChildBase[]>();
export const fxCreateSduiTicket = createEffect<
  CreateTicketPayload,
  CreateUpdateTicketResponse,
  Error
>().use(sdui.createTicket);

export const updateSduiTicket = createEvent<{
  openedId: string | number;
  sduiData: ChildBase[];
}>();
export const fxUpdateSduiTicket = createEffect<
  UpdateTicketPayload,
  CreateUpdateTicketResponse,
  Error
>().use(sdui.updateTicket);

export const $sduiReadonly = createStore(true);
export const setSduiReadonly = createEvent<boolean>();

export const $pending = pending({
  effects: [fxGetCustomFieldsSduiJson, fxCreateSduiTicket, fxUpdateSduiTicket],
});

export const $errorSduiRequests = createStore<Error | null>(null);
export const clearError = createEvent();
export const errorOccured = merge([
  fxGetCustomFieldsSduiJson.fail,
  fxCreateSduiTicket.fail,
  fxUpdateSduiTicket.fail,
]);
